import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import styled from "styled-components";
const InfoView = styled.div `
  width: fit-content;
  height: fit-content;
  @media (max-width: 1023px) {
    height: fit-content;
  }
`;
const InfoStatus = styled.div `
  width: 360rem;
  height: fit-content;
  font-size: 20rem;
  @media (max-width:1023px){
    width: 280rem;
    height: fit-content;
    font-size: 16rem;
  }
`;
const InfoEvent = styled.div `
  width: fit-content;
  height: fit-content;
  font-size: 16rem;
  @media (max-width:1023px){
    width: 280rem;
    height: fit-content;
    font-size: 12rem;
  }
`;
const InfoError = styled.div `
  width: fit-content;
  height: fit-content;
  font-size: 16rem;
  color: #d72c2c;
  @media (max-width:1023px){
    font-size: 14rem;
  }
`;
const HashHref = styled.a `
  width: fit-content;
  height: fit-content;
  font-size: 16rem;
  color: #507cd5;
  margin-left: 15rem;
  @media (max-width:1023px){
    font-size: 14rem;
    margin-left: 14rem;
  }
`;
const ToastPending = ({ info }) => {
    return (_jsxs(InfoView, { children: [_jsx(InfoStatus, { children: "Pending for transaction confirmation..." }), _jsx(InfoEvent, { children: info })] }));
};
const ToastSuccess = ({ info, hashLink }) => {
    return (_jsxs(InfoView, { children: [_jsx(InfoStatus, { children: "Transaction successful \uD83C\uDF89" }), _jsxs(InfoEvent, { children: [info, _jsx(HashHref, { href: '' + hashLink, children: "View on BscScan" })] })] }));
};
const ToastError = ({ info, error }) => {
    return (_jsxs(InfoView, { children: [_jsxs(InfoStatus, { children: ["Transaction failed: ", error] }), _jsx(InfoEvent, { children: info })] }));
};
export { ToastPending, ToastSuccess, ToastError };
